import React from "react";
import classNames from "classnames";
import { Menu } from "@blueprintjs/core";
import * as styles from "./styles.module.scss";
const DefaultMenu = ({ items, onClick, className }) => (React.createElement(Menu, { onClick: onClick, className: classNames(styles.menu, className) }, items));
export default DefaultMenu;
